"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OperatedBy = exports.CityAndCode = exports.Next = exports.Stop = exports.IconLineFirst = exports.IconLineFinal = exports.IconLine = exports.DiscontinuousLineContainer = exports.Title = exports.FlightInfo = exports.RouteAirport = exports.FlightAirport = exports.FlightTitle = exports.Flight = exports.Content = exports.CompanyName = exports.Company = exports.Date = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = _interopRequireDefault(require("color"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  align-items    : flex-start;\n  background     : ", ";\n  border-radius  : ", "px;\n  border         : ", ";\n  display        : flex;\n  flex-direction : column;\n  justify-content: center;\n  padding        : ", "px;\n"])), function (props) {
  return props.whiteBackground ? _palette.palette.white : _palette.palette.darkWhite;
}, _widths.widths.base, function (props) {
  return props.whiteBackground ? "solid 1px ".concat(_palette.palette.bobBlack) : 0;
}, _widths.widths.base * 2);

exports.Container = Container;
Container.displayName = 'Container';

var Date = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  align-content: center;\n  align-items: center;\n  color      : ", ";\n  display: flex;\n  font-size  : 14px;\n  font-weight: ", ";\n  line-height: 1.38;\n  text-align : left;\n"])), _palette.palette.bobBlack, _widths.font.regular);

exports.Date = Date;
Date.displayName = 'Date';

var Company = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  align-content: center;\n  align-items: center;\n  color      : ", ";\n  display          : flex;\n  flex-direction   : row;\n  font-size  : 14px;\n"])), _palette.palette.bobBlack);

exports.Company = Company;
Company.displayName = 'Company';

var CompanyName = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 14px;\n  line-height: 1.38;\n  margin     : 0 ", "px;\n  margin-left: ", "px;\n"])), _palette.palette.bobBlack, _widths.widths.base, function (props) {
  return props.icon ? 0 : _widths.widths.base;
});

exports.CompanyName = CompanyName;
CompanyName.displayName = 'CompanyName';

var Content = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display          : flex;\n  flex-direction   : column;\n"])));

exports.Content = Content;
Content.displayName = 'Content';

var Flight = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  align-items   : center;\n  color         : ", ";\n  display       : flex;\n  flex-direction: column;\n  font-size     : 12px;\n  font-weight   : ", ";\n  margin        : 0 ", "px;\n"])), _palette.palette.bobBlack, _widths.font.semi, _widths.widths.base * 4);

exports.Flight = Flight;
Flight.displayName = 'Flight';

var FlightTitle = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n display: flex;\n flex-direction: column;\n margin-top: ", ";\n"])), function (props) {
  return props.stops ? 0 : "".concat(_widths.widths.base * 2, "px");
});

exports.FlightTitle = FlightTitle;
FlightTitle.displayName = 'FlightTitle';

var FlightAirport = _styledComponents["default"].span(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 14px;\n  font-weight: ", ";\n  line-height: 1.67;\n  text-align : left;\n"])), _palette.palette.grey, _widths.font.regular);

exports.FlightAirport = FlightAirport;
FlightAirport.displayName = 'FlightAirport';

var RouteAirport = _styledComponents["default"].span(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 14px;\n  font-weight: ", ";\n  line-height: 1.67;\n  margin: ", "px 0;\n  text-align : left;\n\n"])), _palette.palette.grey, _widths.font.regular, _widths.widths.base * 3 / 2);

exports.RouteAirport = RouteAirport;
RouteAirport.displayName = 'RouteAirport';

var FlightInfo = _styledComponents["default"].span(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 17px;\n  font-weight: ", ";\n  line-height: 1.67;\n  text-align : left;\n\n"])), _palette.palette.bobBlack, _widths.font.semi);

exports.FlightInfo = FlightInfo;
FlightInfo.displayName = 'FlightInfo';

var Title = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  display: flex;\n  flex-direction: row;\n  font-size  : 20px;\n  font-weight: ", ";\n  margin-bottom: ", "px;\n"])), _palette.palette.bobBlack, _widths.font.semi, _widths.widths.base * 2);

exports.Title = Title;
Title.displayName = 'Title';

var DiscontinuousLineContainer = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", "px;\n"])), _widths.widths.base);

exports.DiscontinuousLineContainer = DiscontinuousLineContainer;
DiscontinuousLineContainer.displayName = 'DiscontinuousLineContainer';

var IconLine = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  left: -", "px;\n  position: absolute;\n  top: 2px;\n"])), _widths.widths.base * 3);

exports.IconLine = IconLine;
IconLine.displayName = 'IconLine';

var IconLineFinal = _styledComponents["default"].div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  bottom: 13px;\n  left: -7px;\n  position: absolute;\n"])));

exports.IconLineFinal = IconLineFinal;
IconLineFinal.displayName = 'IconLineFinal';

var IconLineFirst = _styledComponents["default"].div(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2["default"])(["\n  left: -9px;\n  position: absolute;\n  top: 5px;\n"])));

exports.IconLineFirst = IconLineFirst;
IconLineFirst.displayName = 'IconLineFirst';

var Stop = _styledComponents["default"].div(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: ", "px 0;\n  position: relative;\n"])), _widths.widths.base * 3 / 2);

exports.Stop = Stop;
Stop.displayName = 'Stop';

var Next = _styledComponents["default"].span(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 9px;\n  left: 65px;\n  position: absolute;\n"])));

exports.Next = Next;
Next.displayName = 'Next';

var CityAndCode = _styledComponents["default"].span(_templateObject18 || (_templateObject18 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n"])), function (props) {
  return props.arriveNextDay ? "".concat(_widths.widths.base, "px") : 0;
});

exports.CityAndCode = CityAndCode;

var OperatedBy = _styledComponents["default"].div(_templateObject19 || (_templateObject19 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 14px;\n  font-weight: ", ";\n  line-height: 14px;\n  text-align : left;\n  margin-bottom: ", "px;\n  margin-top: -", "px;\n"])), _palette.palette.grey, _widths.font.regular, _widths.widths.base * 2, _widths.widths.base * 2);

exports.OperatedBy = OperatedBy;